module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTkxMiAxOTJhNDggNDggMCAwIDEgNDcuOCA0My40TDk2MCAyNDB2NTQ0YTQ4IDQ4IDAgMCAxLTQzLjQgNDcuOEw5MTIgODMyaC04MDBhNDggNDggMCAwIDEtNDcuOC00My40TDY0IDc4NHYtNTQ0YTQ4IDQ4IDAgMCAxIDQzLjQtNDcuOEwxMTIgMTkyaDgwMHpNODk2IDI4NS4xbC0zODMuNSAyNjUuNUwxMjggMjk5LjFWNzY4aDc2OFYyODUuMXpNODI1LjUgMjU2SDE3OC45bDMzMi41IDIxNy40TDgyNS41IDI1NnoiIGZpbGw9IiMwIiBwLWlkPSIyMDUwIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Email-outlined.svg
// module id = IrAj
// module chunks = 73